import React, { useContext, useState } from "react";
import { NotifyContext } from "../../context/notifyContext";
import { Subscriber } from "../../Types/newsletter";
import NewsletterAPI from "../../services/api/newsletterService";
import Button from "../../UI/Button/Button";
import ButtonLoading from "../../UI/Button/ButtonLoading";

interface UnsubscribeSubscriberProps {
  onClose: () => void;
  subscriber?: Subscriber | null;
}

export default function UnsubscribeSubscriber({
  onClose,
  subscriber,
}: UnsubscribeSubscriberProps) {
  const notify = useContext(NotifyContext);
  const [loading, setLoading] = useState(false);

  const handleUnsubscribe = async () => {
    if (!subscriber) return;
    setLoading(true);

    try {
      await NewsletterAPI.unsubscribe_subscriber(subscriber.id);
      notify("Abonné désabonné avec succès", "success");
      onClose();
    } catch (error) {
      notify(error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <p>Êtes-vous sûr de vouloir désabonner cet abonné ?</p>
      <div className="flex justify-end gap-2">
        <Button color="error" onClick={onClose}>
          Annuler
        </Button>
        <ButtonLoading
          type="submit"
          loading={loading}
          label="Désabonner"
          onClick={handleUnsubscribe}
        />
      </div>
    </div>
  );
} 